var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"kt-menu__nav"},[_vm._l((_vm.menuItems),function(menu,i){return [(!menu.section)?_c('KTMenuItem',{key:i,attrs:{"menu":menu}}):_vm._e(),(menu.section)?_c('KTMenuSection',{key:i,attrs:{"menu":menu}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }